import WireframeButton from './WireframeButton';
import WireframeNavMenuVertical from './WireframeNaveMenuVertical';
import WireframeNavMenuHorizontal from './WireframeNavMenuHorizontal';
import WireframeMultiSelect from './WireframeMultiSelect';
import WireframeLink from './WireframeLink';
import WireframeInputField from './WireframeInputField';
import WireframeDropdown from './WireframeDropdown';
import WireframeCheckbox from './WireframeCheckbox';
import WireframeDatePicker from './WireframeDatePicker';
import WireframeSearchBar from './WireframeSearchBar';
import WireframeRadioButton from './WireframeRadioButton';
import WireframeToggle from './WireframeToggle';
import WireframeSlider from './WireframeSlider';
import WireframePlaceholder from './WireframePlaceholder';
import WireframeImage from './WireframeImage';
import WireframeDonutChart from './WireframeDonutChart';
import WireframeVideo from './WireframeVideo';
import WireframeMap from './WireframeMap';
import WireframePieChart from './WireframePieChart';
import WireframeBarChart from './WireframeBarChart';
import WireframeLineChart from './WireframeLineChart';
import WireframePill from './WireframePill';
import WireframeAvatar from './WireframeAvatar';
import WireframeScrollBar from './WireframeScrollBar';
import WireframePagination from './WireframePagination';
import WireframeBreadcrumb from './WireframeBreadcrumb';
import WireframeProgressStepper from './WireframeProgressStepper';

export const WIREFRAMES = {
  button: WireframeButton,
  navMenuVertical: WireframeNavMenuVertical,
  navMenuHorizontal: WireframeNavMenuHorizontal,
  multiSelect: WireframeMultiSelect,
  link: WireframeLink,
  inputField: WireframeInputField,
  dropdown: WireframeDropdown,
  checkbox: WireframeCheckbox,
  datePicker: WireframeDatePicker,
  searchBar: WireframeSearchBar,
  radioButton: WireframeRadioButton,
  toggle: WireframeToggle,
  slider: WireframeSlider,
  placeholder: WireframePlaceholder,
  image: WireframeImage,
  video: WireframeVideo,
  map: WireframeMap,
  pieChart: WireframePieChart,
  donutChart: WireframeDonutChart,
  barChart: WireframeBarChart,
  lineChart: WireframeLineChart,
  pill: WireframePill,
  avatar: WireframeAvatar,
  scrollBar: WireframeScrollBar,
  pagination: WireframePagination,
  breadcrumb: WireframeBreadcrumb,
  progressStepper: WireframeProgressStepper,
} as const;

type WireframeClasses = (typeof WIREFRAMES)[keyof typeof WIREFRAMES];

export function wireframeNameToClass(wireframeName: string): WireframeClasses {
  if (wireframeName in WIREFRAMES) {
    return WIREFRAMES[wireframeName];
  }

  throw new Error(`Unknown wireframe name: ${wireframeName}`);
}

export default { wireframeNameToClass };
